import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, CheckCircle, XCircle, AlertTriangle, Clock } from 'lucide-react';
import api from '@/lib/api';

export default function EmbassyDashboard() {
  const [stats, setStats] = useState({ total: 0, pending: 0, approved: 0, rejected: 0, correction_needed: 0 });

  useEffect(() => {
    api.get('/stats/embassy').then(r => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: 'Total dossiers', value: stats.total, icon: FileText, color: '#007FFF' },
    { label: 'En attente', value: stats.pending, icon: Clock, color: '#F7D618' },
    { label: 'Approuves', value: stats.approved, icon: CheckCircle, color: '#009543' },
    { label: 'Rejetes', value: stats.rejected, icon: XCircle, color: '#CE1021' },
    { label: 'Corrections', value: stats.correction_needed, icon: AlertTriangle, color: '#F97316' },
  ];

  return (
    <div className="space-y-6 animate-fade-in" data-testid="embassy-dashboard">
      <h1 className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Portail Ambassade</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <Card key={i} className="border">
              <CardContent className="p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${c.color}15` }}>
                  <Icon className="w-5 h-5" style={{ color: c.color }} />
                </div>
                <div>
                  <p className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>{c.value}</p>
                  <p className="text-xs text-muted-foreground">{c.label}</p>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
